import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  subTitle: string | null;
}

const StyledSubTitle = styled.div`
  font-family: ${props => props.theme.fontFamily};
  color: ${props => props.theme.whiteColor};
  font-weight: 300;
  font-size: 20px;
  min-height: 24px;

  display: flex;
  justify-content: center;
`;

const PageSubTitle = ({ subTitle }: IProps) => (
  <StyledSubTitle>{subTitle}</StyledSubTitle>
);

export default PageSubTitle;